import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import OtpModule from "@/store/modules/OtpModule";
import RepresentModule from "@/store/modules/RepresentModule";
import PartnerModule from "@/store/modules/PartnerModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    OtpModule,
    RepresentModule,
    PartnerModule
  },
});

export default store;
